import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import { Card, Stack, Box, useMediaQuery } from "@mui/material";
import { TableInfoRow, tabletPortrait } from "@qubit/autoparts";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "~/app/store";
import { BatchList } from "~/features/batchList/BatchList";
import { selectBatches } from "~/features/batchList/batchCards.slice";
import { BatchSummaryDto } from "~/types/api";

type AdminBatchTableProps = {
  hasFilters: boolean;
  batchesLoading: boolean;
  batchesError?: string;
  selectedBatch: BatchSummaryDto | null;
  unselectBatch: () => void;
  selectBatch: (batch: BatchSummaryDto) => void;
};

export default function AdminBatchTable(props: AdminBatchTableProps) {
  const { batchesLoading, batchesError, selectedBatch, hasFilters } = props;
  const { t } = useTranslation();
  const isTabletPortrait = useMediaQuery(tabletPortrait);
  const batches = useAppSelector(selectBatches);

  const noBatchesText = hasFilters
    ? t("no batches found try removing filters")
    : t("no batches in progress");

  return (
    <Box
      padding="2px"
      marginTop="15px"
      overflow="hidden"
      className="admin-batches"
      sx={{
        width: isTabletPortrait ? "100%" : "95%"
      }}
    >
      {!batchesLoading && !batches?.length ? (
        <Card sx={{ p: 2, pb: 1 }}>
          <Stack
            justifyContent="center"
            alignItems="center"
            flexDirection="row"
          >
            <SentimentDissatisfiedIcon />
            <TableInfoRow
              textContent={
                batchesError ? t("error loading batches") : noBatchesText
              }
              error={!!batchesError}
            />
          </Stack>
        </Card>
      ) : (
        <BatchList
          selectedBatch={selectedBatch}
          onBatchSelected={(clickedBatch) => {
            if (
              selectedBatch &&
              selectedBatch.batchId === clickedBatch.batchId
            ) {
              props.unselectBatch();
            } else {
              props.selectBatch(clickedBatch);
            }
          }}
          batchesLoading={batchesLoading || !batches}
        />
      )}
    </Box>
  );
}
